// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue");
const LandingPagePrivacyPolicy = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-privacy-policy" */ "@/app/views/client-view/privacy-policy-page/components/landing-page-privacy-policy/landing-page-privacy-policy.vue");
const ClientFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "client-footer" */ "@/app/views/client-view/_shared/client-footer/client-footer.vue");

// Third Party
import $ from "jquery";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Services
import DefaultSettingsService from "@/app/services/main/default-settings/default-settings-service.js";

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: "PrivacyPolicyContainer",
    mixins: [ googleTagManagerMixins ],
    components: {
        ClientHeader,
        LandingPagePrivacyPolicy,
        ClientFooter,
    },
    data() {
        return {
            appLinks: {
                appStoreLink: "https://play.google.com/store/apps/details?id=com.lmdcmobile",
                googlePlayLink: "https://apps.apple.com/ph/app/love-my-dog-club/id1523977343",
            },
            showMainLogo: true,
        };
    },
    created() {
        /* only scroll at the top of the page if there's no hash 
         * case: clicking the "Responsible Breeder" link in the landing page
        */ 
       
        if(!this.$route.hash){
            $("html, body").animate({ scrollTop: 0 }, 500);
        }

        this.getStoreLink();
    },
    methods: {
        getStoreLink() {
            const queryParams = {
                f_code: "LINK",
                f_environment: "MOB",
            };

            DefaultSettingsService.getDefaultSettings(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.appLinks.googlePlayLink = res.data.find((data) => data.id === 1).value;
                    this.appLinks.appStoreLink = res.data.find((data) => data.id === 2).value;
                }
            });
        },
    },
};
